"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const MapLoaderWrapper = styled_components_1.default.div.attrs({
    'data-id': `map-loader`,
})({
    width: '100%',
    height: '100%',
    position: 'relative',
    overflow: 'hidden',
    minWidth: '1px',
    minHeight: '1px',
    '.map-loader': {
        backgroundImage: 'url(/images/map-placeholder.jpg)',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        filter: 'blur(25px)',
        transform: 'scale(1.3)',
    },
});
const MapLoader = ({ className }) => {
    return (react_1.default.createElement(MapLoaderWrapper, { className: `map-loader-wrapper ${className}` },
        react_1.default.createElement("div", { className: "map-loader" })));
};
exports.default = MapLoader;
//# sourceMappingURL=MapLoader.js.map